import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d438332"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "research-group-page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "page-title-text-area" }
const _hoisted_5 = { class: "with-subhead" }
const _hoisted_6 = { class: "subhead" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "generalTab",
    class: "nav-link active",
    "data-bs-toggle": "tab",
    "data-bs-target": "#generalPane",
    role: "tab",
    "aria-controls": "generalPane",
    "aria-selected": "false"
  }, " General ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "sharingTab",
    class: "nav-link",
    "data-bs-toggle": "tab",
    "data-bs-target": "#sharingPane",
    role: "tab",
    "aria-controls": "sharingPane",
    "aria-selected": "true"
  }, " Sharing ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "manageTab",
    class: "nav-link",
    "data-bs-toggle": "tab",
    "data-bs-target": "#managePane",
    role: "tab",
    "aria-controls": "managePane",
    "aria-selected": "true"
  }, " Manage ")
], -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "tab-content content-area" }
const _hoisted_12 = {
  id: "generalPane",
  class: "tab-pane active",
  role: "tabpanel",
  "aria-labelledby": "generalTab",
  tabindex: "0"
}
const _hoisted_13 = { class: "name" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Name ", -1))
const _hoisted_15 = { class: "description" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Description ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " People in this tree ", -1))
const _hoisted_18 = { class: "big-number" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Start person ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Created ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Last synced ", -1))
const _hoisted_22 = {
  id: "sharingPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "sharingTab",
  tabindex: "0"
}
const _hoisted_23 = {
  id: "managePane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "manageTab",
  tabindex: "0"
}

import { computed, reactive, ref } from 'vue'
import { usePageTitle } from '@/util/AppUtil'
import { computedAsync} from '@vueuse/core'
import { useWorkspaceStore } from '@/rd/WorkspaceStore'
import { useSyncStore } from '@/rd/SyncStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { ItemPermissions, DataGroup } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import { DateTimeUtil } from '@/util/LuxonUtil'
import { useTabsTelemetry } from '@/util/TabTelemetry'
import { useInitialTabRouting } from '@/util/InitialTabRouting'
import { useInstantSave } from '@/util/InstantSave'
import { workspaceTypeInfos } from '@/rd/ResearchDataModel'
import ResearchGroupSharing from './ResearchGroupSharing.vue'
import ResearchGroupManage from './ResearchGroupManage.vue'
import UserLink from '@/manage/users/UserLink.vue'
import InPlaceTextEdit from '@/util/InPlaceTextEdit.vue'
import LoadingIndicator from '@/util/LoadingIndicator.vue'
import ProfileCard from '../ProfileCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchGroupPage',
  props: {
  dataGroupId: String
},
  setup(__props) {

const props = __props;



const editDataGroup = reactive(new DataGroup())
const editProperties = [
  'name',
  'description',
] as (keyof DataGroup)[]

const tabsElemRef = ref<HTMLUListElement>()

const workspaceStore = useWorkspaceStore()
const dataGroupStore = useDataGroupStore()
const syncStore = useSyncStore()

const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(props.dataGroupId, LoadMode.EnsureLoaded)?.data)
const workspaceRef = computed(() => workspaceStore.getAsyncWorkspacesForGroups([props.dataGroupId], LoadMode.EnsureLoaded).at(0)?.data)
const logoRef = computed(() => workspaceTypeInfos.find(t => t.id == (workspaceRef.value?.dataFileBaseType ?? 'TestData'))?.icon)
const lastSyncRef = computed(() => syncStore.getAsyncSync(workspaceRef.value?.lastSyncId, LoadMode.EnsureLoaded)?.data)

const statsRef = computedAsync(
  async () => (await workspaceStore.getStatisticsAsync([workspaceRef.value?.id])).at(0))

const permissionsRef = computed(() => dataGroupStore.getAsyncPermissions(props.dataGroupId, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const canEditRef = computed(() => (permissionsRef.value & ItemPermissions.Modify) > 0)

usePageTitle("Tree", () => dataGroupRef.value?.name)
useInitialTabRouting('generalTab')
useTabsTelemetry(tabsElemRef)

useInstantSave(dataGroupRef, editDataGroup, editProperties, 
  changes => dataGroupStore.patchAsync(props.dataGroupId!, changes))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", { src: logoRef.value }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(dataGroupRef.value?.name), 1),
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(_toDisplayString(workspaceRef.value?.workspaceTypeInfo?.description) + " managed by ", 1),
          _createVNode(UserLink, {
            "user-id": dataGroupRef.value?.ownerId,
            dimmed: ""
          }, null, 8, ["user-id"])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("ul", {
        ref_key: "tabsElemRef",
        ref: tabsElemRef,
        class: "nav nav-pills research-group-tabs",
        role: "tablist"
      }, _hoisted_10, 512)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("section", _hoisted_12, [
        (!dataGroupRef.value)
          ? (_openBlock(), _createBlock(LoadingIndicator, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(InPlaceTextEdit, {
                  modelValue: editDataGroup.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editDataGroup.name) = $event)),
                  required: "",
                  disabled: !canEditRef.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(InPlaceTextEdit, {
                  modelValue: editDataGroup.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editDataGroup.description) = $event)),
                  placeholder: "None",
                  disabled: !canEditRef.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(statsRef)?.personCount.toLocaleString()), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _createVNode(ProfileCard, {
                  "person-id": dataGroupRef.value?.startItemId
                }, null, 8, ["person-id"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _createElementVNode("div", null, _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(dataGroupRef.value?.createdDate)), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_21,
                _createElementVNode("div", null, _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(lastSyncRef.value?.createdDate)), 1)
              ])
            ], 64))
      ]),
      _createElementVNode("section", _hoisted_22, [
        _createVNode(ResearchGroupSharing, { "data-group-id": __props.dataGroupId }, null, 8, ["data-group-id"])
      ]),
      _createElementVNode("section", _hoisted_23, [
        _createVNode(ResearchGroupManage, { "data-group-id": __props.dataGroupId }, null, 8, ["data-group-id"])
      ])
    ])
  ]))
}
}

})